module.exports = __webpack_public_path__ + "img/cards1_front164.d1e6b288.png";